import {
  CalculContextState,
  I01EVAECSQUALI3_State,
  I00DEBGAZ_State,
  I00RELGAZPUISS_State,
  I00DIMLIGNEGAZ_State,
  I01EVACONSSYSTECS_State,
  I01EVACONSSYSTECS2_State,
  I01EVAECSQUALI_State,
  I01EVAECSQUALI2_State,
  I01TEMPATT_State,
  I01DEPBOUCECS_State,
  I02CHOIXENERCHAUF_State,
  I02COSTENER_State,
  I03PSYCHROAIR_State,
  I04DIMPUISSCHAUD_State,
  I04DIMPUISCONS_State,
  I04CONVVOLENER_State,
  I04CONCLIMCONS_State,
  I04CONSCHAUFAN_State,
  I06SEPHYD_State,
  I07CALCPUISSRAD_State,
  I08CALCVOLEXP_State,
  I09DIMCIRC_State,
  I10DIABOUCECS_State,
  I11PERCHADISCHA_State,
  I11PERCHARES_State,
  I11PERCHARVARI_State,
  I10DIAMPUISS_State,
  I12VOLINSTCHAUF_State,
  I13VENTCHAUFFIOUL_State,
  I13VENTCHAUFGAZ_State,
  I14V3VREGUL_State,
  I14V2VREGUL_State,
  I16DIMADOUCISSEURECS_State,
  I16DIMADOUCISSEURPRIM_State,
  I17TARIFC16_State,
  I17INFPARCONSEP_State,
  I21RENDETAS_State,
  I04CALCULGSIMP_State,
  I04CALCULGDETA_State,
  I04CALCULGDETAItem_State,
  I18VENTGAINE_State,
  I15MASVOLAPHUML_State,
  I15TEMPRELEVE_State,
  I15HYDROACCU_State,
  I15TEMPLIMITBOIS_State,
  I15DIMSILOBOIS_State,
  I15TAUXCOUVBOIS_State,
  I13VENTCHAUFBOIS_State,
  I10DIAEFCOL_State,
  //[MARKER_FORMULA_IMPORT_CALCUL_STATE]
  P01CREALOGCOL_State,
  CalculCodeStateKeys
} from '@batical/types/src'

import I00DebgazCalcul from './Calculs/I00DebgazCalcul'
import I00DIMLIGNEGAZCalcul from './Calculs/I00DIMLIGNEGAZCalcul'
import I00RELGAZPUISSCalcul from './Calculs/I00RELGAZPUISSCalcul'
import I01DEPBOUCECSCalcul from './Calculs/I01DEPBOUCECSCalcul'
import I01EVACONSSYSTECS2Calcul from './Calculs/I01EVACONSSYSTECS2Calcul'
import I01EVACONSSYSTECSCalcul from './Calculs/I01EVACONSSYSTECSCalcul'
import I01EVAECSQUALI2Calcul from './Calculs/I01EVAECSQUALI2Calcul'
import I01EVAECSQUALI3Calcul from './Calculs/I01EVAECSQUALI3Calcul'
import I01EVAECSQUALICalcul from './Calculs/I01EVAECSQUALICalcul'
import I01TEMPATTCalcul from './Calculs/I01TEMPATTCalcul'
import I02CHOIXENERCHAUFCalcul from './Calculs/I02CHOIXENERCHAUFCalcul'
import I02COSTENERCalcul from './Calculs/I02COSTENERCalcul'
import I03PSYCHROAIRCalcul from './Calculs/I03PSYCHROAIRCalcul'
import I04CALCULGDETACalcul from './Calculs/I04CALCULGDETACalcul'
import I04CALCULGDETAItemCalcul from './Calculs/I04CALCULGDETAItemCalcul'
import I04CALCULGSIMPCalcul from './Calculs/I04CALCULGSIMPCalcul'
import I04CONCLIMCONSCalcul from './Calculs/I04CONCLIMCONSCalcul'
import I04CONSCHAUFANCalcul from './Calculs/I04CONSCHAUFANCalcul'
import I04CONVVOLENERCalcul from './Calculs/I04CONVVOLENERCalcul'
import I04DIMPUISCONSCalcul from './Calculs/I04DIMPUISCONSCalcul'
import I04DIMPUISSCHAUDCalcul from './Calculs/I04DIMPUISSCHAUDCalcul'
import I06SEPHYDCalcul from './Calculs/I06SEPHYDCalcul'
import I07CALCPUISSRADCalcul from './Calculs/I07CALCPUISSRADCalcul'
import I08CALCVOLEXPCalcul from './Calculs/I08CALCVOLEXPCalcul'
import I09DIMCIRCCalcul from './Calculs/I09DIMCIRCCalcul'
import I10DIABOUCECSCalcul from './Calculs/I10DIABOUCECSCalcul'
import I10DIAEFCOLCalcul from './Calculs/I10DIAEFCOLCalcul'
import I10DIAMPUISSCalcul from './Calculs/I10DIAMPUISSCalcul'
import I11PERCHADISCHACalcul from './Calculs/I11PERCHADISCHACalcul'
import I11PERCHARESCalcul from './Calculs/I11PERCHARESCalcul'
import I11PERCHARVARICalcul from './Calculs/I11PERCHARVARICalcul'
import I12VOLINSTCHAUFCalcul from './Calculs/I12VOLINSTCHAUFCalcul'
import I13VENTCHAUFBOISCalcul from './Calculs/I13VENTCHAUFBOISCalcul'
import I13VENTCHAUFFIOULCalcul from './Calculs/I13VENTCHAUFFIOULCalcul'
import I13VENTCHAUFGAZCalcul from './Calculs/I13VENTCHAUFGAZCalcul'
import I14V2VREGULCalcul from './Calculs/I14V2VREGULCalcul'
import I14V3VREGULCalcul from './Calculs/I14V3VREGULCalcul'
import I15DIMSILOBOISCalcul from './Calculs/I15DIMSILOBOISCalcul'
import I15HYDROACCUCalcul from './Calculs/I15HYDROACCUCalcul'
import I15MASVOLAPHUMLCalcul from './Calculs/I15MASVOLAPHUMLCalcul'
import I15TAUXCOUVBOISCalcul from './Calculs/I15TAUXCOUVBOISCalcul'
import I15TEMPLIMITBOISCalcul from './Calculs/I15TEMPLIMITBOISCalcul'
import I15TEMPRELEVECalcul from './Calculs/I15TEMPRELEVECalcul'
import I16DIMADOUCISSEURECSCalcul from './Calculs/I16DIMADOUCISSEURECSCalcul'
import I16DIMADOUCISSEURPRIMCalcul from './Calculs/I16DIMADOUCISSEURPRIMCalcul'
import I17INFPARCONSEPCalcul from './Calculs/I17INFPARCONSEPCalcul'
import I17TARIFC16Calcul from './Calculs/I17TARIFC16Calcul'
import I18VENTGAINECalcul from './Calculs/I18VENTGAINECalcul'
import I21RENDETASCalcul from './Calculs/I21RENDETASCalcul'
import P01CREALOGCOLCalcul from './Projects/P01CREALOGCOLCalcul'
import { isWeb } from './utils'
//[MARKER_IMPORT_CALCUL]

// eslint-disable-next-line import/prefer-default-export
export function doCalcul(calcul: CalculCodeStateKeys, state: CalculContextState): CalculContextState {
  switch (calcul) {
    case 'I00DEBGAZ':
      return I00DebgazCalcul(state as I00DEBGAZ_State)
    case 'I00RELGAZPUISS':
      return I00RELGAZPUISSCalcul(state as I00RELGAZPUISS_State)
    case 'I00DIMLIGNEGAZ':
      return I00DIMLIGNEGAZCalcul(state as I00DIMLIGNEGAZ_State)
    case 'I01EVACONSSYSTECS':
      return I01EVACONSSYSTECSCalcul(state as I01EVACONSSYSTECS_State)
    case 'I01EVACONSSYSTECS2':
      return I01EVACONSSYSTECS2Calcul(state as I01EVACONSSYSTECS2_State)
    case 'I01EVAECSQUALI':
      return I01EVAECSQUALICalcul(state as I01EVAECSQUALI_State)
    case 'I01EVAECSQUALI2':
      return I01EVAECSQUALI2Calcul(state as I01EVAECSQUALI2_State)
    case 'I01EVAECSQUALI3':
      return I01EVAECSQUALI3Calcul(state as I01EVAECSQUALI3_State)
    case 'I01TEMPATT':
      return I01TEMPATTCalcul(state as I01TEMPATT_State)
    case 'I01DEPBOUCECS':
      return I01DEPBOUCECSCalcul(state as I01DEPBOUCECS_State)
    case 'I02CHOIXENERCHAUF':
      return I02CHOIXENERCHAUFCalcul(state as I02CHOIXENERCHAUF_State)
    case 'I02COSTENER':
      return I02COSTENERCalcul(state as I02COSTENER_State, isWeb)
    case 'I03PSYCHROAIR':
      return I03PSYCHROAIRCalcul(state as I03PSYCHROAIR_State)
    case 'I04DIMPUISSCHAUD':
      return I04DIMPUISSCHAUDCalcul(state as I04DIMPUISSCHAUD_State)
    case 'I04CONSCHAUFAN':
      return I04CONSCHAUFANCalcul(state as I04CONSCHAUFAN_State, isWeb)
    case 'I04DIMPUISCONS':
      return I04DIMPUISCONSCalcul(state as I04DIMPUISCONS_State)
    case 'I04CONVVOLENER':
      return I04CONVVOLENERCalcul(state as I04CONVVOLENER_State)
    case 'I04CONCLIMCONS':
      return I04CONCLIMCONSCalcul(state as I04CONCLIMCONS_State, isWeb)
    case 'I06SEPHYD':
      return I06SEPHYDCalcul(state as I06SEPHYD_State)
    case 'I07CALCPUISSRAD':
      return I07CALCPUISSRADCalcul(state as I07CALCPUISSRAD_State)
    case 'I08CALCVOLEXP':
      return I08CALCVOLEXPCalcul(state as I08CALCVOLEXP_State)
    case 'I09DIMCIRC':
      return I09DIMCIRCCalcul(state as I09DIMCIRC_State)
    case 'I10DIABOUCECS':
      return I10DIABOUCECSCalcul(state as I10DIABOUCECS_State)
    case 'I10DIAMPUISS':
      return I10DIAMPUISSCalcul(state as I10DIAMPUISS_State, isWeb)
    case 'I11PERCHADISCHA':
      return I11PERCHADISCHACalcul(state as I11PERCHADISCHA_State)
    case 'I11PERCHARES':
      return I11PERCHARESCalcul(state as I11PERCHARES_State)
    case 'I11PERCHARVARI':
      return I11PERCHARVARICalcul(state as I11PERCHARVARI_State)
    case 'I12VOLINSTCHAUF':
      return I12VOLINSTCHAUFCalcul(state as I12VOLINSTCHAUF_State)
    case 'I13VENTCHAUFFIOUL':
      return I13VENTCHAUFFIOULCalcul(state as I13VENTCHAUFFIOUL_State)
    case 'I13VENTCHAUFGAZ':
      return I13VENTCHAUFGAZCalcul(state as I13VENTCHAUFGAZ_State)
    case 'I14V3VREGUL':
      return I14V3VREGULCalcul(state as I14V3VREGUL_State)
    case 'I14V2VREGUL':
      return I14V2VREGULCalcul(state as I14V2VREGUL_State)
    case 'I16DIMADOUCISSEURECS':
      return I16DIMADOUCISSEURECSCalcul(state as I16DIMADOUCISSEURECS_State)
    case 'I16DIMADOUCISSEURPRIM':
      return I16DIMADOUCISSEURPRIMCalcul(state as I16DIMADOUCISSEURPRIM_State)
    case 'I17INFPARCONSEP':
      return I17INFPARCONSEPCalcul(state as I17INFPARCONSEP_State, isWeb)
    case 'I17TARIFC16':
      return I17TARIFC16Calcul(state as I17TARIFC16_State)
    case 'I18VENTGAINE':
      return I18VENTGAINECalcul(state as I18VENTGAINE_State, isWeb)
    //added from generator
    case 'I21RENDETAS':
      return I21RENDETASCalcul(state as I21RENDETAS_State)
    case 'I04CALCULGSIMP':
      return I04CALCULGSIMPCalcul(state as I04CALCULGSIMP_State)
    case 'I04CALCULGDETA':
      return I04CALCULGDETACalcul(state as I04CALCULGDETA_State, isWeb)
    case 'I04CALCULGDETAItem':
      return I04CALCULGDETAItemCalcul(state as I04CALCULGDETAItem_State, isWeb)
    case 'P01CREALOGCOL':
      return P01CREALOGCOLCalcul(state as P01CREALOGCOL_State)
    case 'I15MASVOLAPHUML':
      return I15MASVOLAPHUMLCalcul(state as I15MASVOLAPHUML_State)
    case 'I15TEMPRELEVE':
      return I15TEMPRELEVECalcul(state as I15TEMPRELEVE_State)
    case 'I15HYDROACCU':
      return I15HYDROACCUCalcul(state as I15HYDROACCU_State)
    case 'I15TEMPLIMITBOIS':
      return I15TEMPLIMITBOISCalcul(state as I15TEMPLIMITBOIS_State)
    case 'I15DIMSILOBOIS':
      return I15DIMSILOBOISCalcul(state as I15DIMSILOBOIS_State)
    case 'I15TAUXCOUVBOIS':
      return I15TAUXCOUVBOISCalcul(state as I15TAUXCOUVBOIS_State)
    case 'I13VENTCHAUFBOIS':
      return I13VENTCHAUFBOISCalcul(state as I13VENTCHAUFBOIS_State)
    case 'I10DIAEFCOL':
      return I10DIAEFCOLCalcul(state as I10DIAEFCOL_State)
    default:
      return state
  }
}
